import types from "./types"

const initState = {
    configsLoading: false,
    configs: {},
};

export default function configs(
    state = initState,
    action,
) {
    switch (action.type) {
        case types.SET_CONFIGS_LOADING:
            return {
                ...state,
                configsLoading: action.data,
            };
        case types.SET_CONFIG:
            return {
                ...state,
                configs: { ...state.configs, [action.payload.key]: action.payload.value },
            };
        default:
            return state;
    }
}
